import request from "@/utils/request";

export interface LoginParams {
  username?: string;
  password?: string;
}

export interface LoginResult {
  googleUrl: string;
  isOpenGoogleCheck: boolean;
  loginPrepareToken: string;
}

export interface VerifyCodeParams {
  loginPrepareToken: string;
  googleCode: number;
}

export interface VerifyCodeResult {
  token: string;
}

export interface SysMenuDataItem {
  id: number;
  pid: number;
  name: string;
  nameEn?: string;
  address: string;
  icon: string;
  sort: number;
  visible: string;
  type: number; // 1页面 2按钮
  createdAt: number;
  updatedAt: number;
  children: SysMenuDataItem[] | null;
}

export interface UserInfo {
  id: number;
  userName: string;
  nickName: string;
  isSuper: boolean;
  menus: SysMenuDataItem[];
  agentLevel?: number; // 1表示平台 2:一级代理 3:二级代理 4:商户
  operatorId?: number;
  fee?: number; // 费率
}

/** 登录接口 POST /api/v1/sys-login */
export async function login(
  body: LoginParams,
  options?: { [key: string]: any },
) {
  return request<LoginResult>("/api/v1/sys-login", {
    method: "POST",
    data: body,
    ...(options || {}),
  });
}

/** 登录验证码校验接口 POST /api/v1/sys-login-verify-code */
export async function verifyCode(
  body: VerifyCodeParams,
  options?: { [key: string]: any },
) {
  return request<VerifyCodeResult>("/api/v1/sys-login-verify-code", {
    method: "POST",
    data: body,
    ...(options || {}),
  });
}

/** 获取当前登录用户信息 GET /api/v1/sys-user-info */
export async function getUserInfo(options?: { [key: string]: any }) {
  return request<UserInfo>("/api/v1/sys/userinfo", {
    method: "GET",
    ...(options || {}),
  });
}

/** 运营商登录接口 POST /api/v1/sys-login-operator */
export async function loginOperator(
  params: { loginVerifyToken: string },
  options?: { [key: string]: any },
) {
  return request<VerifyCodeResult>("/api/v1/sys-login-operator", {
    method: "POST",
    data: params,
    ...(options || {}),
  });
}
